<template>
  <div id="home">
    <BsHeaderView @toggle="menuToggle"></BsHeaderView>
    <div class="container-fluid" style="min-height: 100%">
      <!-- {{ jancode_obj }} -->
      <div class="row row-eq-height">
        <bs-side-menu-view :display-sw="menuDisplay"></bs-side-menu-view>
        <main :class="mainDisplayClass">
          <router-view></router-view>
        </main>
      </div>
    </div>
    <BsFooterView></BsFooterView>
  </div>
</template>
<style scoped>
.row-eq-height {
  display: flex;
  flex-wrap: wrap;
}
.table tbody tr td {
  vertical-align: middle !important;
}
</style>
<script>
// import Vue from 'vue'
import BsHeaderView from '../organisms/BsHeaderView.vue'
import BsFooterView from '../organisms/BsFooterView.vue'
import BsSideMenuView from '../organisms/BsSideMenuView.vue'
import { mapState } from 'vuex'
// import config from '../../const'
// import axios from 'axios'
export default {
  name: 'templateOwnerView',
  data: function () {
    return {
      menuDisplay: true
    }
  },
  computed: {
    ...mapState({}),
    mainDisplayClass() {
      if (this.menuDisplay) {
        return 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
      } else {
        return 'col-md-12 ms-sm-auto col-lg-12 px-md-4'
      }
    }
  },
  components: {
    BsHeaderView,
    BsFooterView,
    BsSideMenuView
  },
  created() {},
  methods: {
    menuOpen() {},
    menuToggle() {
      console.log('toggle !!')
      if (this.menuDisplay) {
        this.menuDisplay = false
      } else {
        this.menuDisplay = true
      }
    }
  }
}
</script>

<style scoped>
@import '../../assets/bootstrap/css/dashboard.css';
</style>
